export default "__VITE_ASSET__B8Eecm2Z__"